// extracted by mini-css-extract-plugin
export default {"result":"kPVbUj","pay-wrapper":"KnYYsO"};